import React, { useState, useEffect } from "react";
import { ArrowRightCircle, X } from "lucide-react";
import "./CourseEnrollCTA.css";
import { Link, useNavigate } from "react-router-dom";

export default function CourseEnrollCTA() {
  const [visible, setVisible] = useState(true);

  // Optional: show CTA only after user scrolls some
  // useEffect(() => {
  //   const onScroll = () => {
  //     if (window.scrollY > 200) setVisible(true);
  //     else setVisible(false);
  //   };
  //   window.addEventListener("scroll", onScroll);
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, []);

  if (!visible) return null;

  
  const sessionData = sessionStorage.getItem("studentSession");
  const token = sessionData ? JSON.parse(sessionData)?.token : null;
  const redirectUrl = token ? "/dashboard" : "/login";


  return (
    <div className="course-enroll-cta-container" role="region" aria-label="Enroll Now Call to Action">
      <div className="course-enroll-cta-content">
        <span className="course-enroll-cta-text">
          Ready to start your UPSC journey?
        </span>


        <Link
          to={redirectUrl}
          onClick={() => {
            sessionStorage.setItem("redirectFrom", window.location.pathname);
          }}
        >
          <button className="course-enroll-cta-button">
            Enroll Now <ArrowRightCircle size={24} />
          </button>
        </Link>

      </div>
      <button
        className="course-enroll-cta-close"
        onClick={() => setVisible(false)}
        aria-label="Close enrollment call to action"
      >
        <X size={20} />
      </button>
    </div>
  );
}
